<template>
  <div>

    <base-header class="pb-0 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">eSIM Account Activity</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <div class="p-5 bg-white">
      <b-container class="flex-cols">
        <h2>Activity Log</h2>
        <div class="table-responsive">
          <b-table
            head-row-variant="primary"

            id="activityTable"
            :items="activity_data"
            :fields="activity_fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            show-empty
            borderless
            striped
            fixed
          >
            <template #cell(Status)="row">
              <base-button size="xs" :type="getStateClass(row.item['Status'])">{{ row.item['Status'] }}</base-button>
            </template>
            <template #cell(Details)="row">
              <base-button size="xs" type="light" v-on:click="getActivityDetail(row.item['id'])">
                <b-icon icon="info-circle-fill" aria-label="More"></b-icon>
              </base-button>
            </template>
            <template #empty="scope">
              <b>{{ scope.emptyText }}</b>
            </template>
            <template #emptyfiltered="scope">
              <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
          <br>
          <b-container class="text-xs">
            <b-row>
              <b-col class="text-left">{{ resultsFound }}</b-col>
              <b-col class="text-center">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="pageSize"
                  aria-controls="blacklistTable"
                  align="center"
                ></b-pagination>
              </b-col>
              <b-col class="text-right">{{ resultsUpdated }}</b-col>
            </b-row>
          </b-container>
        </div>
      </b-container>
    </div>

    <b-modal id="activityModal" size="xs" centered hide-footer>
      <template #modal-title>
        Log details
      </template>
      <div class="table-responsive">
        <table class="table-bordered" cellpadding="10" cellspacing="2">
          <tr>
            <td colspan="2">
              <b>Profile Management</b><br>
              <i>{{ activity.invocationName }}</i><br>
            </td>
          </tr>
          <tr>
            <td class="bg-light">Profile-Id</td>
            <td>{{ activity.profileId }}</td>
          </tr>
          <tr>
            <td colspan="2" class="bg-light">
              <b>Invocation</b><br>
            </td>
          </tr>
          <tr>
            <td class="bg-light">Date</td>
            <td>{{ activity.processingStart }}</td>
          </tr>
          <tr>
            <td class="bg-light">ID</td>
            <td>{{ activity.invocationId }}</td>
          </tr>
          <tr>
            <td class="bg-light">Duration</td>
            <td>({{ activity.duration }}) ms</td>
          </tr>
        </table>
      </div>
    </b-modal>

    <b-alert v-model="alertShow" :variant="alertVariant" dismissible class="mx-auto container-fluid">
      {{ alertMessage }}
    </b-alert>

  </div>

</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import commonService from "@/common/api-services/common";

export default {
  components: {
    RouteBreadCrumb,
  },

  data() {
    return {
      submitLoading: false,
      showResults: false,

      resultsFound: '',
      resultsUpdated: '',
      sortBy: 'Modified',
      sortDesc: true,
      pageSize: 1,
      currentPage: 1,
      totalRows: 1,
      totalPages: 1,

      //activity list
      activity_data_src: [],
      activity_data: [],
      activity_fields: [
        {key: 'Feature', label: 'Feature', sortable: true},
        {key: 'Action', label: 'Operation', sortable: true},
        {key: 'User', label: 'User', sortable: true},
        {key: 'Modified', label: 'Date', sortable: true},
        {key: 'Status', label: 'Status', sortable: true},
        {key: 'Details', label: '', sortable: false},
      ],
      activity_title: [{key: 'title', label: 'Activity Log'}],
      activity: [],

      //setup for alert
      alertShow: false,
      alertVariant: 'success',
      alertMessage: '',
    }
  },

  mounted() {
    document.title = 'eSIM - Activity ';
    this.getActivityData();
  },

  methods: {

    async getActivityData() {
      await eSimDashboardService.getActivity('').then(res => {
        this.activity_data_src = res;
        let d = [];
        res.results.forEach(item => {
          //invocationId
          let id = item.invocationId;
          //Feature
          let f = 'Profile Management';
          //Action
          let a = commonService.getLastKey(item.invocationName, '.', ' ', true);
          //User .auditIdentifiers['name']=USER_NAME (value)
          let u = 'Unknown';
          item.auditIdentifiers.forEach(row => {
            if (row.name === 'USER_NAME') u = row.value;
          });
          //Modified
          let m = commonService.unixToDate(item.processingEnd);
          //Status
          let s = JSON.parse(item.jsonResult).header.functionExecutionStatus.status.split('-')[1].toUpperCase();
          //add row to data object
          d.push({id: id, Feature: f, Action: a, User: u, Modified: m, Status: s});
        });

        this.totalRows = res.pageInfo.totalPages;
        this.totalPages = res.pageInfo.totalElements;
        this.pageSize = res.pageInfo.size;
        this.currentPage = res.pageInfo.number + 1;
        if (this.totalPages<1) this.totalPages=1;

        this.resultsFound = '';//`Page ${res.pageInfo.number + 1} of ${res.pageInfo.size} of ${res.pageInfo.numberOfElements}`;//res.pageInfo.numberOfElements;
        this.resultsUpdated = '';//commonService.strToDate(Date.now(), 'DD MMM, YYYY HH:mm:ss');

        this.activity_data = d;
      }).catch(err => {
        this.showToasterMsg('getOrderProfile Error: ' + err.message, true, 'danger');
      });
    },

    getActivityDetail(id) {
      eSimDashboardService.getActivityDetail(id).then(res => {
        //now show the model.
        res.invocationName = commonService.getLastKey(res.invocationName, '.', ' ', true);
        res.duration = ((res.processingEnd - res.processingStart));
        let profileId = 'Unknown';
        res.auditIdentifiers.forEach(row => {
          if (row.name === 'Profile-Id') profileId = row.value;
        });
        res.profileId = profileId;
        this.activity = res;
        this.$bvModal.show('activityModal');
      });
    },

    getStateClass(state) {
      let sstate = `${state}`;//convert to string
      sstate = sstate.toLowerCase();
      let sclass = '';
      if (sstate === 'released' || sstate === 'ok' || sstate === 'success' || sstate === 'available') {
        sclass = 'success';
      } else if (sstate === 'failed' || sstate === 'error' || sstate === 'cancel') {
        sclass = 'danger';
      } else if (sstate === 'info') {
        sclass = 'info';
      } else {
        sclass = 'warning';
      }
      //console.log('getStateClass[state][class]', sstate, sclass);
      return sclass;
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //setup for alert
      this.alertVariant = variant;
      this.alertMessage = message;
      this.alertShow = true;
    },
  },
}
</script>
<style>
.table thead th {
  background-color: #5e72e4 !important;
  color: #ffffff !important;
  background-image: none !important;
  border-spacing: 0px !important;
  border-right: 1px solid #5e72e4 !important;
}

.table tbody td {
  background-color: #ffffff !important;
  color: #000000 !important;
  background-image: none !important;
  border-bottom: 1px solid #AAAAAA !important;
}
</style>
